// extracted by mini-css-extract-plugin
module.exports = {"root":"SupportInfoText_root_36FQR","title":"SupportInfoText_title_1TjWm","description":"SupportInfoText_description_VfNqp"};